import { Accordion as AccordionPrimitive } from "@base-ui/react/accordion";
import { motion } from "motion/react";
import type * as React from "react";
import { ChevronDown } from "untitledui-js/react";

import { cn } from "@bidbattles/bloks/lib/ui";

const AccordionPrimitiveRoot = motion.create(AccordionPrimitive.Root);
function Accordion({
	...props
}: React.ComponentProps<typeof AccordionPrimitiveRoot>) {
	return <AccordionPrimitiveRoot layout {...props} />;
}

const AccordionPrimitiveItem = motion.create(AccordionPrimitive.Item);
function AccordionItem({
	className,
	...props
}: React.ComponentProps<typeof AccordionPrimitiveItem>) {
	return (
		<AccordionPrimitiveItem
			layout
			className={cn("border-b border-gray-300 last:border-b-0", className)}
			{...props}
		/>
	);
}

function AccordionTrigger({
	className,
	children,
	...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
	return (
		<AccordionPrimitive.Header className="flex">
			<AccordionPrimitive.Trigger
				data-slot="accordion-trigger"
				className={cn(
					"group flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none cursor-pointer disabled:cursor-auto disabled:pointer-events-none disabled:opacity-50",
					"focus-visible:z-1 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-gray-400 ease-in-out duration-100",
					className,
				)}
				{...props}
			>
				{children}
				<ChevronDown className="text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200 group-data-panel-open:rotate-180" />
			</AccordionPrimitive.Trigger>
		</AccordionPrimitive.Header>
	);
}

function AccordionContent({
	className,
	children,
	...props
}: React.ComponentProps<typeof AccordionPrimitive.Panel>) {
	return (
		<AccordionPrimitive.Panel
			data-slot="accordion-content"
			className="h-(--accordion-panel-height) overflow-hidden text-sm transition-[height] ease-out data-ending-style:h-0 data-starting-style:h-0"
			{...props}
		>
			<div className={cn("pt-0 pb-4", className)}>{children}</div>
		</AccordionPrimitive.Panel>
	);
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
